import {
  USER_LOGOUT_START,
  USER_LOGOUT_SUCCESS,
  USER_LOGOUT_ERROR,
  SET_RUNTIME_VARIABLE
} from '../constants';
import axios from 'axios';
import history from '../core/history';
import { userLogout as query } from '../lib/graphql';
import { removeCookies } from '../helpers/cookies';

export function setUserLogout({ isAdmin }) {

  return async (dispatch, getState, { client }) => {

    dispatch({
      type: USER_LOGOUT_START,
    });

    try {
      const { data } = await client.query({ query, fetchPolicy: 'network-only' });

      if (data?.userLogout?.status == "success") {
        // Redirect to Home page
        removeCookies({ name: 'id_token' });
        await axios.get(`/expire-token`);
        
        isAdmin ? history.push('/siteadmin/login') : history.push('/');
        window.location.reload();


        // Successully logged out
        dispatch({
          type: USER_LOGOUT_SUCCESS
        });

        // Update the Authentication status
        dispatch({
          type: SET_RUNTIME_VARIABLE,
          payload: {
            name: 'isAuthenticated',
            value: false,
          }
        });


      } else {
        dispatch({
          type: USER_LOGOUT_ERROR,
        });
      }
    } catch (error) {
      dispatch({
        type: USER_LOGOUT_ERROR,
        payload: {
          error
        }
      });
      return false;
    }

    return true;
  };
}
